import React from 'react'
import { Div } from 'glamorous'

import Icon, { ICON_FLAME } from 'components/common/Icon'
import Text from 'components/common/Text'
import PremiumBenefit from './PremiumBenefit'

const LoginContent = props => {
  return (
    <Div
      paddingTop={16}
      paddingLeft={24}
      paddingRight={24}
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      <Icon width={80} height={80} path={ICON_FLAME} />
      <Div width="100%" paddingTop={6} paddingBottom={14}>
        <Text size={16} color="black">Login with Facebook for unlimited Swipes and Rewinds.</Text>
        <PremiumBenefit title="Unlimited Swipes" text="Out of Swipes? Like as many people as you want." />
        <PremiumBenefit title="Unlimited Rewinds" text="Accidentally passed on someone? Rewind and Swipe again." />
      </Div>
    </Div>
  )
}

export default LoginContent



// WEBPACK FOOTER //
// ./src/components/modal/LoginContent.js